<!--  -->
<template>
  <div>
    <div class>
      <Steps :active="0" :space="'20%'" :stepsShow="true" align-center>
        <Step
          :title="$t('cert.baseinfo')"
          @click.native="on_click('certbase')"
        />
        <Step
          :title="$t('cert.ralacourse')"
          @click.native="on_click('certcourse')"
        />
        <Step
          :title="$t('cert.certtemplaterule')"
          @click.native="on_click('certrule')"
        />
        <Step
          :title="$t('cert.recertrule')"
          v-if="recertFlag == '10'"
          @click.native="on_click('certrerule')"
        />
        <Step
          :title="$t('cert.certassessmentdate')"
          v-if="dataForm.ballFive == '10'"
          @click.native="on_click('certreassessment')"
        />
      </Steps>
    </div>
    <div style="margin-top: 20px; margin-bottom: 20px"></div>
    <el-card class="aui-card--fill" shadow="never">
      <!-- 基本信息设定 -->
      <div class="page_title">{{ $t("cert.baseinfoset") }}</div>
      <el-form
        label-position="top"
        label-width="auto"
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
      >
        <el-row :gutter="0">
          <!-- 认证编号 -->
          <el-col :span="6">
            <el-form-item :label="$t('cert.certCode')" prop="certCode">
              <el-input
                v-model="dataForm.certCode"
                :disabled="true"
                :placeholder="$t('cert.autobysystem')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 认证中文名称 -->
          <el-col :span="6">
            <el-form-item prop="certNameCn">
              <span style="color: #f56c6c">*&nbsp;</span
              >{{ $t("cert.certNameCn") }}
              <!-- <span slot="label" style="display: inline-block"><div class="link-type"
                     >{{ $t('cert.certNameCn')}}</div></span> -->
              <el-input
                v-model="dataForm.certNameCn"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 认证英文名称 -->
          <el-col :span="6">
            <el-form-item prop="certNameEn">
              <span style="color: #f56c6c">*&nbsp;</span
              >{{ $t("cert.certNameEn") }}
              <el-input
                v-model="dataForm.certNameEn"
                :disabled="true"
                :maxlength="200"
                :placeholder="$t('cert.inputTips')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 品牌 -->
          <el-col :span="6">
            <el-form-item prop="brandCode">
              <span style="color: #f56c6c">*&nbsp;</span>{{ $t("cert.brand") }}
              <el-select
                v-model="dataForm.brandCode"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item, index) in brandArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <!-- 认证分类 -->
          <el-col :span="6">
            <el-form-item prop="certType">
              <span style="color: #f56c6c">*&nbsp;</span
              >{{ $t("cert.certType") }}
              <el-select
                v-model="dataForm.certType"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item, index) in certTypeArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 认证级别 -->
          <el-col :span="6">
            <el-form-item prop="certLevel">
              <span style="color: #f56c6c">*&nbsp;</span
              >{{ $t("cert.certLevel") }}
              <el-select
                v-model="dataForm.certLevel"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item, index) in certLevelArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 团队分类 -->
          <!-- <el-col :span="6">
            <el-form-item :label="$t('cert.courseTeamCatalog')"
                          prop="courseTeamCatalogId">
              <courseTeamCatalogtree @catalogidListVisiblelist="catalogidListVisiblelist"
                                     :defaultProps="defaultPropsVisible"
                                     :showArray="showTeamCatalogListVisible"
                                     :showValue="showValueVisible"
                                     :url="queryTreeUrlVisible"
                                     :isSelect=true
                                     :status="'classStatus'"
                                     ref="classRef"></courseTeamCatalogtree>

            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <div style="width: 67%; display: flex">
              <div style="width: 50%">
                <el-form-item
                  prop="courseTeamCatalogFirst"
                  style="width: 100% !important"
                  :label="$t('cert.courseTeamCatalog')"
                >
                  <!-- <span style="color: #f56c6c">*&nbsp;</span
                  >{{ $t("cert.courseTeamCatalog") }} -->
                  <!-- <div id="container"> -->
                  <div class="box01" style="width: auto; float: left">
                    <el-select
                      v-model="dataForm.courseTeamCatalogFirst"
                      :placeholder="$t('cert.selectTips')"
                      :disabled="true"
                      @change="GetcourseTeamCatalog($event)"
                    >
                      <el-option
                        v-for="item in select1"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div style="width: 50%">
                <el-form-item
                  prop="courseTeamCatalogSecond"
                  style="width: 100% !important"
                >
                  <div class="el-form-item__label"></div>
                  <div class="box02" style="width: auto; float: left">
                    <el-select
                      v-model="dataForm.courseTeamCatalogSecond"
                      placeholder=" "
                      :disabled="true"
                      :loading="loading"
                      @change="getList($event)"
                    >
                      <el-option
                        v-for="item in select2"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </div>
                  <!-- </div> -->
                </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item prop="file"
                          class="upload-img-form"
                          :label="$t('cert.appcertbadge')"
                          ref="uploadElement">

            </el-form-item>
            <el-table-column :label="$t('cert.appcertbadge')"
                             width="300">
              <template slot-scope>
                <img alt="" :src='picURL+this.dataForm.iconUrl+tokens'
                     width="300"
                     height="300"
                     class="head_pic" />
              </template>
            </el-table-column>
          </el-col>
        </el-row> -->
        <el-row>
            <div class="msg">
               <div slot="header" class="clearfix">
                    <span>{{$t('cert.FCC')}}</span>
                </div>
                <div class="introduce-container">
                    <div class="introduce-list">
                        <template v-for="(introduce, index) in dataForm.introduceList">
                            <div :key="index" class="introduce-item">
                                <template v-if=" introduce.introduceType == '10'">
                                    <el-row>
                                        <el-col :span="10" class="content">
                                            <el-input :disabled="true" type="textarea"  v-model="introduce.introduceContent" :maxlength="500"  placeholder="$t('cert.pleaseEntertext')" show-word-limit></el-input>
                                            <!-- <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em> -->
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="introduce.introduceType == '20'">
                                    <div class="media-warpper content">
                                        <img alt="" :src="introduce.introduceUrl">
                                        <!-- <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em> -->
                                    </div>
                                </template>
                                <template v-else-if="introduce.introduceType == '30'">
                                    <div style="display: flex;">
                                        <div class="media-warpper content">
                                            <video :src="introduce.videoUrl" controls/>
                                            <!-- <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em> -->
                                        </div>
                                        <div class="media-warpper content1" >
                                            <img alt="" :src="introduce.videoHeadUrl">
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                    <!-- <div v-if="!isView" class="bottom-btns">
                        <em class="el-icon-circle-plus">{{$t('cert.addTexts')}}</em>
                        <em class="el-icon-circle-plus">{{$t('cert.addImage')}}</em>
                        <em class="el-icon-circle-plus">{{$t('cert.addVedio')}}</em>
                    </div>
                    <br>
                    <div v-if="!isView">
                         {{$t('cert.TextCannotExceed')}}<br>{{$t('cert.VedioCannotExceed')}} 
                    </div> -->
                </div>
                <el-upload
                        ref="introduce-img"
                        :headers="headers"
                        :action="actionUrl"
                        accept=".jpg,.png,.jpeg"
                        :on-success="introduceImgUploadSuccess"
                        :show-file-list="false"
                        :beforeUpload="beforeImgUpload">
                </el-upload>
                <el-upload
                        ref="introduce-video"
                        :headers="headers"
                        :action="actionUrl"
                        accept=".mp4, .mov"
                        :show-file-list="true"
                        :beforeUpload="beforeVideoUpload"
                        :on-success="introduceVideoUploadSuccess">
                </el-upload>
                </div>
        </el-row>
      </el-form>
    </el-card>
    <div style="text-align: right">
      <el-row :gutter="0">
        <el-col :span="24"> </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="24">
          <el-button @click="next" type="primary">{{
            $t("cert.next")
          }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Vue from 'vue'
import courseTeamCatalogtree from "../../common/courseTeamCatalogtree";
import selectCertName from "../selectCertName";
import Steps from "../../common/steps/index";
import Step from "../../common/steps/src/step";
import ZElButton from "../../common/button/index";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    courseTeamCatalogtree,
    selectCertName,
    Steps,
    Step,
    ZElButton,
  },
  props: {
    requiredData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
       introduceList: [],
        // 上传地址
                actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/imgUpload',
                type: null,
                formData:{
                    managedata:{
                        themeId: null,
                        themeTitle: "", //话题名称
                        themeIntro: "", //话题简介
                        fileName: "", //文件名称
                        fileUrl: "", //文件路径
                        caregoryId: null, //话题分类
                        tags: [],   //标签集合
                        brandsList:[],
                    },
                },
      tokens: `?token=${this.getStorage(this.GLOBAL.TOKEN)}`,
      picURL: `${window.SITE_CONFIG["apiURL"]}/learning/courseinfo/downloadpic/`,
      // brandArr: this.enums['brandCode'], // 品牌
      brandArr: this.enums["certBrand"], // 品牌
      certTypeArr: this.enums["certType"], // 认证分类
      certLevelArr: this.enums["certLevel"], // 认证级别
      certNameCnArr: this.enums["certName"], // 认证中文名
      // 认证中文名称选择
      selectCertNameDialog: false,
      dictTypeDialog: "certName",
      // 课程团队分类树数据取得
      queryTreeUrlVisible: "/learning/coursecatalog/list",
      // 课程团队树
      defaultPropsVisible: {
        children: "children",
        label: "catalogNameCn",
        id: "catalogId",
      },
      showTeamCatalogListVisible: [],
      showValueVisible: "",
      recertFlag: "",
      dataForm: {
        certId: "",
        certCode: "",
        certNameCn: "",
        certNameCnName: "",
        certNameEn: "",
        brandCode: "",
        certType: "",
        certLevel: "",
        iconUrl: "",
        selectYear: "",
        courseTeamCatalogFirst: "",
        courseTeamCatalogSecond: "",
        ballFive: "",
        introduceContent: '',
        introduceUrl: "",
        videoUrl: '',
        introduceList:[]
      },
      // 课程团队分类数据 Start
      select1: this.enums["catalogidList1"],
      // [
      //   { value: '10', label: 'BBS-50' },
      //   { value: '20', label: 'BBS-51' },
      //   { value: '30', label: 'BBS-52' },
      //   { value: '40', label: 'BBS-53' },
      //   { value: '50', label: 'H5' },
      //   { value: '60', label: 'Non TA' }],
      loading: false,
      select2: [],
      allteamcatalog: this.enums["catalogidList2"],
      // [
      //   { pro: '10', label: '50' },
      //   { pro: '20', label: 'BP' }, { pro: '20', label: 'ME' }, { pro: '20', label: 'Others' },
      //   { pro: '30', label: 'MA' }, { pro: '30', label: 'S&M' }, { pro: '30', label: 'Others' },
      //   { pro: '40', label: 'Parts' }, { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
      //   { pro: '50', label: 'H5' },
      //   { pro: '60', label: 'CRM Coaching' }, { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' }

      // ],
      // 课程团队分类数据 End
      dataRule: {
        // certNo: [{ required: true, message: this.$t('cert.inputTips') + this.$t('cert.certCode'), trigger: 'blur' }],
        // certNameCnName: [{ required: true, message: this.$t('cert.inputTips') + this.$t('cert.certNameCn'), trigger: ['blur', 'change'] }],
        // certNameEn: [{ required: true, message: this.$t('cert.inputTips') + this.$t('cert.certNameEn'), trigger: 'blur' }],
        // brandCode: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.brand'), trigger: 'change' }],
        // certType: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.certType'), trigger: 'change' }],
        // certLevel: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.certLevel'), trigger: 'change' }],
        // courseTeamCatalogId: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.courseTeamCatalog'), trigger: 'change' }]
      },
    };
  },

  // 监听属性 类似于data概念
  computed: {
      //是否为查看
            isView(){
                return this.type == "view"
            },
                 // 获取请求头
            headers: function headers () {
                let headersObj = {
                    token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
                }
                return headersObj
            }
  },

  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log("mounted");
  },
  beforeCreate() {
    console.log("beforeCreate");
  }, // 生命周期 - 创建之前
  beforeMount() {
    console.log("beforeMount");
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
    console.log("beforeUpdate");
  }, // 生命周期 - 更新之前
  updated() {
    console.log("updated");
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    console.log("beforeDestroy");
  }, // 生命周期 - 销毁之前
  destroyed() {
    console.log("destroyed");
  }, // 生命周期 - 销毁完成
  activated() {
    this.requiredData.recertFlag = this.recertFlag;
    this.init();
  },

  // 方法集合
  methods: {
           //话题介绍图片上传
            introduceImgUploadSuccess(response){
                this.introduceList.push(new Introduce("20", response.data))
            },
            //话题介绍视频上传
            introduceVideoUploadSuccess(response){
                this.introduceList.push(new Introduce("30", response.data))
             },
                  beforeImgUpload(file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传jpg/png/jpeg文件')
                    return false
                }
                let isLt2M = file.size / 1024 / 1024 <= 20
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过20MB!')
                    return false
                }
            },
            beforeVideoUpload(file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['mp4', 'mov', 'MP4', 'MOV']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传mp4/mov格式视频')
                    return false
                }
                let isLt2M = file.size / 1024 / 1024 <= 1000
                if (!isLt2M) {
                    this.$message.warning('上传视频大小不能超过1G!')
                    return false
                }
            },
            //删除话题介绍
            delIntroduce(index){
                this.introduceList.splice(index, 1)
            },
           addText(){
                this.introduceList.push(new Introduce("10"))
            },
            addImage(){
                this.$refs['introduce-img'].$children[0].$refs.input.click()
            },
            addVideo(){
                this.$refs['introduce-video'].$children[0].$refs.input.click()
            },
      // 查询详情数据
            getInfo() {
                //清空表单
                console.log(2, this.formData)
                if(this.isAdd){
                    //新增不访问接口
                    return
                }else {
                    this.formData.managedata.themeTitle = ''
                    this.formData.managedata.themeIntro = ''
                    this.formData.managedata.fileName = ''
                    this.formData.managedata.fileUrl = ''
                    this.formData.managedata.caregoryId = null
                    this.formData.managedata.tags = []
                    this.formData.introduceList = []
                    this.formData.managedata.brandsList = []
                    this.themeStatus = ""
                    this.usersCon = []
                }
                this.$request
                    .get(`/grow/theme/getDetail/${this.formData.themeId}`)
                    .then((res, total, code, data) => {
                        Object.getOwnPropertyNames(this.formData.managedata).forEach(key => {
                            let val = data.data.managedata[key]
                            val && (this.formData.managedata[key] = val)
                        })
                        this.formData.managedata.brandsList = [];
                        for(var i = 0; i < data.data.managedata.brandsList.length; i++) {
                            this.formData.managedata.brandsList.push(data.data.managedata.brandsList[i]);
                        }
                        this.themeStatus = data.data.managedata.themeStatus
                        // 话题补充图片水印
                        this.introduceList = data.data.introduceList
                        this.formData.managedata.tags = data.data.tags
                        this.usersCon=data.data.guest
                        this.usersCon.forEach(item=>{
                            if (item.userType==='2'){
                                this.initiatorTag = true
                            }else if (item.userType==='1'){
                                this.guesTag = true
                            }
                        })
                        if (this.initiatorTag && this.guesTag) {
                            this.guestDashed = true
                        }
                        if(this.isInitBrand == false){
                            var brandArr = this.enums['brandCode'];
                            try{
                                for(var i = 0; i < brandArr.length; i++){
                                    if(brandArr[i].code){
                                        this.brands.push(brandArr[i]);
                                    }
                                }
                                this.isInitBrand = true;
                            }
                            catch(e) {
                                console.log(e.message);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
    init() {
      let certId = this.$route.query.certId;
      if (certId !== null && certId !== undefined) {
        this.recertFlag = this.requiredData.recertFlag;
        this.dataForm.ballFive = this.requiredData.ballFive;
        this.$request
          .post(`/learning/certinfo/queryCertInfo`, { certId: certId })
          .then((res, total, code, data) => {
            if (data.data.certId !== null) {
              this.dataForm.certId = data.data.certId;
              this.dataForm.certCode = data.data.certCode;
              this.dataForm.certNameCn = data.data.certNameCn;
              this.dataForm.certNameEn = data.data.certNameEn;
              this.dataForm.introduceList = data.data.introduceList
              this.dataForm.introduceContent = data.data.introduceList.introduceContent;
              this.dataForm.videoUrl =  data.data.introduceList.videoUrl;
              this.dataForm.introduceUrl = data.data.introduceList.introduceUrl;
              this.dataForm.brandCode = data.data.brandCode;
              this.dataForm.iconUrl = data.data.iconUrl;
              this.dataForm.certType = data.data.certType;
              this.dataForm.certLevel = data.data.certLevel;
              this.dataForm.courseTeamCatalogFirst =
                data.data.courseTeamCatalogFirst;
              // 取得二级数据
              this.GetcourseTeamCatalog(data.data.courseTeamCatalogFirst);
              this.dataForm.courseTeamCatalogSecond =
                data.data.courseTeamCatalogSecond;
            }
          });
      }
    },
    initClick() {
      let certId = this.dataForm.certId;
      if (certId !== null && certId !== undefined) {
        // this.recertFlag = this.requiredData.recertFlag
        this.dataForm.selectYear = this.requiredData.selectYear;
        this.$request
          .post(`/learning/certinfo/queryCertInfo`, { certId: certId })
          .then((res, total, code, data) => {
            this.dataForm.certId = certId;
            this.dataForm.certCode = data.data.certCode;
            this.dataForm.certNameCn = data.data.certNameCn;
            this.dataForm.certNameEn = data.data.certNameEn;
            this.dataForm.brandCode = data.data.brandCode;
            this.dataForm.certStatus = data.data.certStatus;
            this.dataForm.certType = data.data.certType;
            this.dataForm.iconUrl = data.data.iconUrl;
            this.dataForm.certLevel = data.data.certLevel;
            this.dataForm.introduceList = data.data.introduceList
            this.dataForm.introduceContent = data.data.introduceList.introduceContent;
            this.dataForm.videoUrl =  data.data.introduceList.videoUrl;
            this.dataForm.introduceUrl = data.data.introduceList.introduceUrl;
            this.dataForm.courseTeamCatalogFirst = 
              data.data.courseTeamCatalogFirst;
            // 取得二级数据
            this.GetcourseTeamCatalog(data.data.courseTeamCatalogFirst);
            this.dataForm.courseTeamCatalogSecond =
              data.data.courseTeamCatalogSecond;
            this.control();
            this.dataForm.yearScrollLeft = 0;
            this.$emit("onCallback", this.dataForm);
          });
      }
    },
    control() {
      this.$request
        .post(`/learning/certinfo/queryCertRuleInfo`, {
          certId: this.dataForm.certId,
          annual: this.dataForm.selectYear,
        })
        .then((res, total, code, data) => {
          this.recertFlag = data.data.recertFlag;
          this.dataForm.ballFive = data.data.isCompensation;
        });
    },
    on_click(stepname) {
      if (stepname === "certbase") {
        return false;
      }
      this.$emit("onShowModer", stepname);
    },
    // 课程团队分类假数据 Start
    // // 课程团队分类调用树
    // catalogidListVisiblelist: function (data) {
    //   console.info(this.brandArr)
    //   console.info(this.certTypeArr)
    //   console.info(this.certLevelArr)
    //   let catalogId = ''
    //   let catalogNameCn = ''
    //   data[0].data.forEach(rows => {
    //     catalogId = catalogId + rows.catalogId + ','
    //     catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
    //   })
    //   // this.$message(catalogId)
    //   this.dataForm.courseTeamCatalogId = catalogId
    // },
    GetcourseTeamCatalog(prov) {
      let tempArry = [];
      this.select2 = [];
      if (
        this.dataForm.courseTeamCatalogSecond !== null ||
        this.dataForm.courseTeamCatalogSecond === ""
      ) {
        this.dataForm.courseTeamCatalogSecond = "";
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2);
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code });
        }
        this.select2 = tempArry;
      }
    },
    getList(opt) {
      console.log(opt);
    },
    // 课程团队分类数据 End
    next() {
      this.$emit("onShowModer", "certcourse");
    },
  }, // 如果页面有keep-alive缓存功能，这个函数会触发
};



    //话题介绍对象
    function Introduce(type, content){
        this.introduceType = type
        // this.introduceContent = content
    }
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
 pre {
        white-space: normal;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        font-family: BMWGlobalProReg, "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-size: 14px;
    }

    .introduce-list{
        margin-top: 20px;
        .introduce-item{

            .content{
                overflow: visible;
                position: relative;
                .remove-icon{
                    position: absolute;
                    right: -40px;
                    top: 5px;
                    z-index: 999999;
                    cursor: pointer;
                    font-size: 24px;
                    background-color: unset;
                    color: red;
                }
            }
            .content::before{
                content: "*";
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1::before{
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1 {
                margin-left: 5px;
            }
            margin-bottom: 20px;
        }
    }
    .media-warpper{
        position: relative;
        width: 220px;
        height: 100px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        border: solid 1px #e0e3e9;
        border-radius: 5px;
        overflow: hidden;
        .avatar-uploader-icon{
            font-size: 50px;
            color: #b5b5b5;
        }
        *{
            max-width: 100%;
            max-height: 100%;
        }
        .remove-icon{
            position: absolute;
            top: 0px;
            right: 0;
            background: #dfdfdf;
            padding: 0 8px;
        }
    }
    .bottom-btns{
        >*{
            cursor: no-drop;
            margin-right: 20px;
            display: inline-flex;
            align-items: center;
        }
        >*::before{
            color: #67d58d;
            font-size: 22px;
            transform: translateY(1px);
            margin-right: 5px;
        }
    }
    // textarea字数提示
    /deep/ .el-input__count{
        font-size: 12px !important;
    }
</style>
